import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import styles from './adminEvents.module.scss';
import { Navigate } from 'react-router-dom';

const AdminLoginPage = () => {
    const auth = useAuth();
    const navigate = useNavigate();

    if (!auth) {
        return <div>Auth provider is missing.</div>;
    }

    if (auth.isLoading) return <div style={{ padding: 24 }}>Loading...</div>;
    if (auth.error) return <div style={{ padding: 24 }}>Error: {auth.error.message}</div>;
    if (auth.isAuthenticated) return <Navigate to="/admin/home" replace />;

    return (
        <div style={{ padding: 24 }}>
            <h1>Admin Login</h1>
            <button onClick={() => auth.signinRedirect()}>Sign in with Cognito</button>
        </div>
    );
};

export default AdminLoginPage;